import { ContentImageProps } from 'components/molecules/ContentImage';
import { TrackingDescriptionIDType } from 'defs/tracking';
import { TrackingDescriptionImageWrapperDtoType } from 'types/services/magnolia/dtos/TrackingDescriptionImageWrapperDto';
import { TrackingDescriptionActionType } from './trackingDescription.actionCreators';
import { CLOSE, LOAD_SUCCESS, OPEN } from './trackingDescription.actionTypes';

export type TrackingDescriptionInternalType = {
	type: TrackingDescriptionIDType;
	headLine: string;
	images: TrackingDescriptionImageWrapperDtoType[];
};

export type TrackingDescriptionType = {
	type: TrackingDescriptionIDType;
	headLine: string;
	images: ContentImageProps[];
};

export type TrackingDescriptionStateType = {
	readonly descriptions: TrackingDescriptionInternalType[];
	readonly loaded: boolean;
} & {
	readonly [guideId: string]: boolean;
};

export type RootStateType = {
	trackingDescription: TrackingDescriptionStateType;
};

export const initialState: TrackingDescriptionStateType = {
	descriptions: [] as any,
	loaded: false,
};

const switchStateFlag = (
	state: TrackingDescriptionStateType,
	descriptionId: TrackingDescriptionIDType,
	flag: boolean
): TrackingDescriptionStateType => {
	if (state[descriptionId] === flag) {
		return state;
	}

	return {
		...state,
		[descriptionId]: flag,
	} as any;
};

export default (state: TrackingDescriptionStateType = initialState, action: TrackingDescriptionActionType) => {
	switch (action.type) {
		case LOAD_SUCCESS:
			return {
				...state,
				descriptions: action.descriptions,
				loaded: true,
			};
		case OPEN:
			return switchStateFlag(state, action.descriptionId, true);

		case CLOSE:
			return switchStateFlag(state, action.descriptionId, false);
		default:
			return state;
	}
};
